// 兼容 huey-twofestival
/**
 * 基于原来有的代码逻辑进行调整, 增加备注与代码注释去升级维护
 * 删除以前无用的AB测 移除手机号
 * 最新的只留俩种方案, 千万不要乱开AB测，测试完就要删除
 */
Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};

var lottery_prize_img_src = "";//'//bloomchic.au/cdn/shop/t/20/assets/lottery-logo-prize15.png?v=183557598104347864051741768443' + new Date().getTime();
var lottery_prize_ticket_img_src = "";// "//bloomchic.au/cdn/shop/t/20/assets/lottery-ticket15.png?v=110023270928178041631741768457" + new Date().getTime();
var lottery_api_address = window.Bloom.global.api_url;
var lottery = {};
lottery.data = {
  popup_enabled: false,
  is_lottery: false,
  is_login:false,
  email: "",
  is_new: true,
  has_order: false,
  prize_code: "",
  lottery_time: null,
  lotterying: false,
  last_auto_show_time: null,
  close_activity_time: null,
  mark: {
    view: null,
    addtocart: null,
    checkout: null,
  },
  result: null,
  click_item: 1,
  popup_source: null,
  loading_interval: null,
  pointer_clicking: false,
  // abtest0924: 'C',
  ab_type: "A", // 默认A  B方案不是转盘
  // 是否填写sms，默认0
  has_sms: 0
  // abc_test_type: "D",
};
/*
lottery.data.is_lottery = false;
lottery.data.is_login =false;
lottery.data.email = "";
lottery.data.is_new = true;
lottery.data.has_order = false;
lottery.data.prize_code = "";
lottery.data.lottery_time = null;
lottery.data.ab_type = "A";
lottery.data.abc_test_type = "D";
lottery.data.lotterying = false;
lottery.data.last_auto_show_time = null;
lottery.data.close_activity_time = null;
lottery.data.mark = {};
lottery.data.result = null;
lottery.data.mark.view = null;
lottery.data.mark.addtocart = null;
lottery.data.mark.checkout = null;
lottery.data.click_item = 1;
lottery.data.popup_source = null;
lottery.loading_interval = null;
lottery.data.pointer_clicking = false;
lottery.data.abtest0924 = 'C';
*/
lottery.base = {
  show() {
    $(".lottery-base").addClass("lottery-base-show");
    $("html").css("overflow", "hidden");
  },
  hide() {
    $(".lottery-base").removeClass("lottery-base-show");
    $("html").css("overflow", "auto");
  }
}
// lottery.base = {
//   hide() {
//     if ($(".lottery-prize-main").is(":visible")) {
//       lottery.prize.hide();
//       lottery.logo.show();
//     }
//   },
// };

// 新增统一处理
function handle_email_error(email_check_result, email, phone) {
  clearInterval(lottery.loading_interval);
  $(".lottery-wheel-close").show();
  $(".lottery-wheel-panel").css("animation", "lottery-wheel-shake 1.6s ease-in-out infinite alternate");
  $(".lottery-wheel-email .lottery-wheel-form-input-border").addClass('empty-error')
  bloomchic_sensor?.lottery?.StarSpinTheWheel(lottery.data.click_item, email_check_result, email, phone);
  $(".lottery-wheel-form-button span").text(lottery.data.ab_type != "B" ? "Spin the wheel" : "Unlock 15% Off");
  // $(".lottery-wheel-form-button img").show();
  // $(".lottery-wheel-form-button").css("background-color","rgba(0,0,0)");
}

lottery.wheel = {
  show(isAuto) {
    console.log('isAuto', isAuto)
    $('.lottery-wheel-main').removeClass("lottery-wheel-main-out")
    $('.lottery-wheel-main').addClass("lottery-wheel-main-in")
    if (isAuto) {
      if (lottery.data.lottery_time == null) {
        if (
          lottery.data.last_auto_show_time == null ||
          lottery.data.last_auto_show_time.getTime() + 24 * 60 * 60 * 1000 <
          new Date().getTime()
        ) {
          lottery.data.last_auto_show_time = new Date();
          localStorage.setItem("lottery-last_auto_show_time",lottery.data.last_auto_show_time.valueOf());
          if (lottery.data.popup_enabled) {
            lottery.data.popup_source = 2;
            lottery.step.show();
          } else {
            lottery.wheel.show();
          }
          $("html").css("overflow", "hidden");
          lottery.logo.hide();
          return true;
        } else {
          return false;
        }
      }
    } else {
      lottery.data.popup_source = 2;
      $(".lottery-wheel-main").show();
      lottery.base.show();
      bloomchic_sensor?.lottery?.SpinPopupShow();
      lottery.logo.hide();
    }
    if (lottery.data.is_login) {
      $(".lottery-wheel-form-email").val(lottery.data.email);
    }
  },
  hide() {
    $('.lottery-wheel-main').removeClass("lottery-wheel-main-in")
    $('.lottery-wheel-main').addClass("lottery-wheel-main-out")
    lottery.base.hide()
    lottery.data.lotterying = false;
    $('.lottery-wheel-form-button, .lottery-wheel-pointer').removeClass('noclick')
    $(".lottery-wheel-form-input input").removeAttr("disabled");
    $(".lottery-wheel-form-error div").hide();
    $(".lottery-wheel-form-input input").val("");
    setTimeout(() => {
      $(".lottery-wheel-main").hide();
      $('.lottery-wheel-main').removeClass("lottery-wheel-main-out")
    }, 500)
  },
  verify(email, phone, agree = true) {
    $(".lottery-wheel-form-error div").hide();
    function verify_email(email) {
      var email_reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var result = email_reg.test(email);
      $(".lottery-wheel-form-email-error .valid")[result?"hide":"show"]();
      $(".lottery-wheel-email .lottery-wheel-form-input-border")[result?"removeClass":"addClass"]("empty-error");
      // if (
      //   !(lottery.data.pointer_clicking && lottery.data.abc_test_type == "A")
      // ) {
      //   if (result) {
      //     $(".lottery-wheel-form-email-error .valid").hide();
      //   } else {
      //     setTimeout(() => {
      //       if (!$(".lottery-wheel-form-email-error .empty").is(":visible")) {
      //         $(".lottery-wheel-form-email-error .valid").show();
      //       }
      //     }, 200);
      //   }
      // }
      // if (!result) {
      //   bloomchic_sensor.lottery.StarSpinTheWheel(lottery.data.click_item,2,email);
      // } else if (lottery.abc_test_type == "A") {
      //   bloomchic_sensor.lottery.StarSpinTheWheel(lottery.data.click_item,5,email);
      //   lottery.data.pointer_clicking = false;
      // }
      return result;
    }

    function verify_phone(phone) {
      var phone_reg = /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/;
      var result = phone_reg.test(phone);
      $(".lottery-wheel-form-phone-error .valid")[result?'hide':'show']()
      bloomchic_sensor.lottery.PhoneInput(result ? 1 : 2);
      return result;
    }
    function verify_agree() {
      $(".lottery-wheel-form-email-error .agree").hide();
      var checkbox = $('#lottery-agree-status');
      if (checkbox.hasClass('noverify')) {
        return true
      }
      var isckeced = checkbox.is(':checked')
      $(".lottery-wheel-form-email-error .agree")[isckeced?'hide':'show']()
      return isckeced      
    }
    var is_legal = false;
    if (email != "")
      is_legal = verify_email(email);
    else {
      $(".lottery-wheel-form-email-error div").hide();
      $(".lottery-wheel-form-email-error .empty").show();
      bloomchic_sensor.lottery.StarSpinTheWheel(lottery.data.click_item,2,email);
    }
    // verify_email(email) && verify_phone(phone);
    var isagree = true
    if (is_legal && agree) {
      isagree = verify_agree(isagree)
    }
    console.log('is_legal && isagree', is_legal && isagree)
    return is_legal && isagree;
  },
  action(email, phone) {
    // 保留旧的 get_random_rotate
    function get_random_rotate(result) {
      var min, max;
      min = {
        5: 35,
        10: 95,
        15: 155,
        20: 215,
        50: 335,
        0: 275
      }[result];
      min += 5;
      min += 1800;
      max = min + 40;
      return Math.round(Math.random() * (max - min) + min);
    }

    // sms请求统一处理
    function handle_sms_error(check_result) {
      clearInterval(lottery.loading_interval);
      $(".lottery-wheel-close").show();
      $(".lottery-wheel-panel").css("animation", "lottery-wheel-shake 1.6s ease-in-out infinite alternate");
      $("#lottery-phone .lottery-wheel-form-input-border").addClass('empty-error')
      bloomchic_sensor.lottery.StarSpinTheWheelSMS(lottery.data.click_item, check_result, email, phone);
      $(".lottery-wheel-form-button span").text(lottery.data.ab_type != "B" ? "Spin the wheel" : "Unlock 15% Off");
      // $(".lottery-wheel-form-button img").show();
      // $(".lottery-wheel-form-button").css("background-color","rgba(0,0,0)");
    }

    function showToastErr() {
      // 仅有当是SMS填入，关闭操作触发抽奖报错才执行
      if(lottery.data.click_item === 3) {
        theme.toast.show({message:'Network error, please refresh and try again!'})
      }
    }

    $(".lottery-wheel-form-input input").attr("disabled", "disabled");
    $(".lottery-wheel-close, .lottery-wheel-phone-close").hide();
    lottery.data.lotterying = true;
    lottery.wheel.loading('phone');
    var post_data = {};
    post_data.email = email;
    post_data.phone = phone;
    post_data.type = lottery.data.ab_type;// lottery.data.abtest0924.toLocaleLowerCase();
    post_data.subscribe = 1 // subscribe 0, 1
  
    $.getJSON(
      lottery_api_address + "/lottery/lottery",
      post_data,
      function (data, textStatus, jqXHR) {
        var lottery_wheel_deg = 0;
        switch (data.code) {
          case 200:
            $(".lottery-wheel-panel").css("animation", "none");
            setTimeout(() => {
              let _resutl = data.data.lottery.result;
              /* 展示结果 */
              lottery_wheel_deg = get_random_rotate(_resutl);
              /* 存储抽奖结果 */
              localStorage.setItem("lottery-email", data.data.lottery.email);
              localStorage.setItem("lottery-phone", phone);
              localStorage.setItem("mar_email", data.data.lottery.email);
              lottery.data.lottery_time = new Date(
                data.data.lottery.created_time * 1000
              );
              localStorage.setItem("lottery-time",lottery.data.lottery_time.valueOf());
              localStorage.setItem("lottery-prize", data.data.lottery.code);
              lottery.data.prize_code = data.data.lottery.code;
              lottery.data.result = data.data.lottery.result;
              lottery.activity.get_result();
              lottery.timer.active();
              // 方案切换
              if (lottery.data.ab_type != 'B') {
                $(".lottery-wheel-panel").css("transform","rotate(" + lottery_wheel_deg + "deg)");
                setTimeout(() => {
                  lottery.wheel.hide();
                  lottery.base.show()
                  setTimeout(() => {
                    lottery.prize.show();
                  }, 500)
                }, 6000);
              } else {
                setTimeout(() => {
                  lottery.wheel.hide();
                  lottery.base.show()
                  setTimeout(() => {
                    lottery.prize.show();
                  }, 500)
                }, 1200)
              }
              if(!lottery.data.has_sms) {
                bloomchic_sensor.lottery.StarSpinTheWheel(lottery.data.click_item, 1, email);
              } else {
                bloomchic_sensor.lottery.StarSpinTheWheelSMS(lottery.data.click_item, 1, email, phone )
              }
              theme.SMSsubscribe({ type: 1, phone, email }, false)
            }, 500);
            break;
          case 20010:
            $(".lottery-wheel-form-email-error .used").show();
            handle_email_error(4, email, phone);
            showToastErr()
            break;
          case 20009:
            $(".lottery-wheel-form-email-error .only-new").show();
            handle_email_error(3, email, phone);
            showToastErr()
            break;
          case 20012:
            $(".lottery-wheel-phone-error .valid").show();
            handle_sms_error(2);
            break;
          case 20011:
            $(".lottery-wheel-phone-error .only-new").show();
            handle_sms_error(3);
            break;
          case 500:
            $(".lottery-wheel-phone-error .network").show();
            handle_sms_error(4);
            break;
        }
        lottery.wheel.resetLoading()
        // lottery.data.lotterying = false;
        // $('.lottery-wheel-form-button, .lottery-wheel-pointer').removeClass('noclick')
        // $(".lottery-wheel-form-input input").removeAttr("disabled");
        if (lottery.data.is_login) {
          $(".lottery-wheel-form-email").attr("disabled", "disabled");
        }
        lottery.data.pointer_clicking = false;
      }
    ).fail(function() {
      lottery.wheel.error()
      showToastErr()
      throw new Error('Lottery Get Is Error') // 可以触发上报
    })
  },
  loading(type='form') {
    var loading_count = 0;
    lottery.loading_interval = setInterval(() => {
      if (lottery.data.lotterying) {
        loading_count = (loading_count + 1) % 4;
        var loading_text = ".";
        loading_text = loading_text.repeat(loading_count);
        loading_text = "Processing" + loading_text;
        type === 'form' && $(".lottery-wheel-form-button span").text(loading_text);
        type === 'phone' && $(".lottery-wheel-phone-button span").text(loading_text);
      }
    }, 500);
  },
  error() {
    lottery.data.lotterying = false;
    clearInterval(lottery.loading_interval)
    $('.lottery-wheel-form-button, .lottery-wheel-pointer').removeClass('noclick')
    $(".lottery-wheel-form-input input").removeAttr("disabled");
    $(".lottery-wheel-form-email-error div").hide()
    $(".lottery-wheel-phone-error").find('.network').show();
    $(".lottery-wheel-form-email-error").find('.network').show();
    $(".lottery-wheel-form-button span").text('Spin the wheel');
    $(".lottery-wheel-phone-button span").text('Spin the wheel');
  },
  // 将按钮重置未触发状态
  resetLoading() {
    lottery.data.lotterying = false;
    clearInterval(lottery.loading_interval)
    $('.lottery-wheel-form-button, .lottery-wheel-pointer').removeClass('noclick')
    $('.lottery-wheel-phone-button').removeClass('noclick')
    $(".lottery-wheel-form-button span").text('Spin the wheel');
    $(".lottery-wheel-phone-button span").text('Spin the wheel');
    $(".lottery-wheel-form-input input").removeAttr("disabled");
  }
};
lottery.logo = {
  show() {
    logo2_animation();
    if (lottery.data.result != null) {
      $(".lottery-logo2-image img").attr("src", lottery_prize_img_src);
      $(".lottery-prize-image img").data("src", lottery_prize_ticket_img_src);
      $(".lottery-logo").show();
    } else {
      $(".lottery-logo2").show();
    }
    $('#lottery-agree-status').prop('checked', false);
    // }
    bloomchic_sensor?.lottery?.SpinEntryShow();
  },
  hide() {
    $(".lottery-logo").hide();
    $(".lottery-logo2").hide();
  },
};
lottery.giveup = {
  show() {
    lottery.base.show()
    $(".lottery-giveup-main").show();
    bloomchic_sensor.lottery.CloseConfirmShow(lottery.data.popup_source);
  },
  hide() {
    lottery.base.hide()
    $(".lottery-giveup-main").hide();
  },
};
lottery.prize = {
  show() {
    lottery.base.show();
    $(".lottery-prize-main").show();
    if (lottery.data.result != null) {
      $(".lottery-logo-image").text(lottery.data.result + "% OFF");
      $(".lottery-prize-image img").attr("src", lottery_prize_ticket_img_src);
    }
    bloomchic_sensor?.lottery?.SpinResultShow();
  },
  hide() {
    lottery.base.hide();
    $(".lottery-prize-main").hide();
  },
};
lottery.activity = {
  get_email() {
    if (lottery.data.email != "" && lottery.data.email != null) {
      localStorage.setItem("lottery-email", lottery.data.email);
    } else {
      lottery.data.email = localStorage.getItem("lottery-email");
    }
    return lottery.data.email;
  },
  get_result() {
    if (lottery.data.result != "" && lottery.data.result != null) {
      localStorage.setItem("lottery-result", lottery.data.result);
    } else {
      lottery.data.result = localStorage.getItem("lottery-result");
    }
    return lottery.data.result;
  },
  get_lotteryTime() {
    if (lottery.data.lottery_time != "" && lottery.data.lottery_time != null) {
      localStorage.setItem(
        "lottery-time",
        lottery.data.lottery_time.valueOf()
      );
    } else {
      var _lottery_time = localStorage.getItem("lottery-time");
      if (_lottery_time != null)
        lottery.data.lottery_time = new Date(_lottery_time);
    }
    return lottery.data.lottery_time;
  },
  get_last_auto_show_time() {
    if (
      lottery.data.last_auto_show_time != "" &&
      lottery.data.last_auto_show_time != null
    ) {
      localStorage.setItem(
        "lottery-last_auto_show_time",
        lottery.data.last_auto_show_time.valueOf()
      );
    } else {
      var _last_auto_show_time = localStorage.getItem(
        "lottery-last_auto_show_time"
      );
      if (_last_auto_show_time != null)
        lottery.data.last_auto_show_time = new Date(_last_auto_show_time);
    }
    return lottery.data.last_auto_show_time;
  },
  get_close_activity_time() {
    if (
      lottery.data.close_activity_time != "" &&
      lottery.data.close_activity_time != null
    ) {
      localStorage.setItem(
        "lottery-close_activity_time",
        lottery.data.close_activity_time.valueOf()
      );
    } else {
      var _close_activity_time = localStorage.getItem(
        "lottery-close_activity_time"
      );
      if (_close_activity_time != null)
        lottery.data.close_activity_time = new Date(_close_activity_time);
    }
    return lottery.data.close_activity_time;
  },
  // get_abtest0924() {
  //   if (lottery.data.abtest0924 != "" && lottery.data.abtest0924 != null) {
  //     localStorage.setItem("lottery-abtest0924", lottery.data.abtest0924);
  //   } else {
  //     lottery.data.abtest0924 = localStorage.getItem("lottery-abtest0924");
  //   }
  //   return lottery.data.abtest0924;
  // },
  getUTCDate(d) {
    var date = new Date(d)
    return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours() - 8, date.getMinutes(), date.getSeconds())
  },
  // 当返回true的时候表示弹窗弹出成功
  check_email() {
    return new Promise((resolve, reject) => {
      if (lottery.data.email != "" && lottery.data.email != null) {
        var post_data = {};
        post_data.email = lottery.data.email;
        $.getJSON(
          lottery_api_address + "/lottery/status",
          post_data,
          function (data, textStatus, jqXHR) {
            lottery.data.has_order = data.data.order;
            if (!lottery.data.has_order) {
              if (data.data.lottery != "") {
                lottery.data.lottery_time = new Date(
                  data.data.lottery.created_time * 1000
                );
                lottery.data.prize_code = data.data.lottery.code;
                lottery.data.result = data.data.lottery.result;
                lottery_prize_img_src = window.lottery_prize[lottery.data.result];
                lottery_prize_ticket_img_src = window.lottery_prize[lottery.data.result];
              }
              if (
                lottery.data.close_activity_time == null || lottery.data.close_activity_time.getTime() + 24 * 60 * 60 * 1000 < new Date().getTime()
              ) {
                // 表示弹窗没有自动弹出过
                if (lottery.data.last_auto_show_time == null ||
                  lottery.data.last_auto_show_time.getTime() + 24 * 60 * 60 * 1000 <
                  new Date().getTime()) {
                    resolve(true)
                  }
                lottery.activity.show();
                window.mark_measure && window.mark_measure('lottery_show')
              }
            }
            reject('弹出失败')
          }
        );
      } else {
        if (lottery.data.close_activity_time == null || lottery.data.close_activity_time.getTime() + 24 * 60 * 60 * 1000 < new Date().getTime()) {
          // 表示弹窗没有自动弹出过
          if (lottery.data.last_auto_show_time == null ||
            lottery.data.last_auto_show_time.getTime() + 24 * 60 * 60 * 1000 <
            new Date().getTime()) {
            resolve(true)
          }
          lottery.activity.show()
        }
        reject('弹出失败')
      }
    })
  },
  checkHidden() {
    if (window.location.search.indexOf('utm_campaign=referralcandy')) {
      return true
    }
    return false
  },
  show() {
    /**
     * 来源为 referralcandy 则不显示转盘
     * 详细方法`sinppets/referralcandy.liquid`
     **/
    // if (
    //   rfcd &&
    //   (rfcd.checkSource() || (localStorage.getItem(rfcd.key) && !rfcd.checkTimeValid()))
    // ) {
    //   return
    // }
    if (lottery.data.lottery_time != null) {
      var endTime = lottery.data.lottery_time.getTime() + 60 * 60 * 2 * 1000;
      if (endTime > new Date().getTime()) {
        lottery.timer.active();
        setTimeout(() => {
          lottery.logo.show();
        }, 1000);
      }
    } else {
      var auto_show_wheel = setInterval(() => {
        // console.log('=====auto_show_wheel', lottery_abtest_loaded)
        if (lottery_abtest_loaded) {
          if (!lottery.wheel.show(true)) {
            lottery.logo.show();
            // clearInterval(auto_show_wheel);
          }
          clearInterval(auto_show_wheel);
        }
      }, 200);
    }
  },
  hide() {
    lottery.logo.hide();
    lottery.wheel.hide();
    lottery.prize.hide();
    lottery.data.close_activity_time = new Date();
    var _close_activity_time = lottery.data.close_activity_time.valueOf();
    localStorage.setItem("lottery-close_activity_time", _close_activity_time);
  },
  login() {
    var _email = $(".lottery-logo").data("email");
    if (_email != "") {
      lottery.data.is_login = true;
      lottery.data.email = _email;
      if (lottery.data.is_login) {
        $(".lottery-wheel-form-email").attr("disabled", "disabled");
      }
    }
  },
};
lottery.timer = {
  active() {
    function checkTime(i) {
      return i < 10 ? "0" + i : i.toString();
    }
    function get_timer_value(_endTime, filter = false) {
      var leftTime = _endTime - new Date().getTime();
      var hours = checkTime(parseInt((leftTime / 1000 / 60 / 60) % 24, 10));
      var minutes = checkTime(parseInt((leftTime / 1000 / 60) % 60, 10));
      var seconds = checkTime(parseInt((leftTime / 1000) % 60, 10));
      var result = "<span>"+hours+"</span>:" + "<span>"+minutes+"</span>:"+ "<span>"+seconds+"</span>"
      if (filter) {
        result = hours+":"+minutes+":"+seconds;
      }
      return result;
    }
    lottery_prize_img_src = window.lottery_prize[lottery.data.result]
    lottery_prize_ticket_img_src = window.lottery_prize[lottery.data.result]
    $(".lottery-prize-coupon em").text(lottery.data.prize_code);
    $("#copy_code").attr('data-clipboard-text', lottery.data.prize_code);
    // $(".lottery-logo-image img").attr("src", lottery_prize_img_src);
    $(".lottery-logo-image").text(lottery.data.result + "% OFF");
    $(".lottery-prize-image img").attr("src", lottery_prize_ticket_img_src);
    $(".lottery-logo-close").hide();
    var counter = setInterval(() => {
      var endTime = lottery.data.lottery_time.getTime() + 60 * 60 * 2 * 1000;
      if (endTime > new Date().getTime()) {
        var time_show = get_timer_value(endTime, true);
        var time_show2 = get_timer_value(endTime, false)
        $(".lottery-logo-msg").html(time_show);
        $('.lottery-prize-timer-counter').html(time_show2);
        // $("#count-down22").html(time_show.replace(/\s/g, "").replace("<span>", "").replace("</span>", ""));
        // $("#cartLimitA22").show();
      } else {
        clearInterval(counter);
        lottery.activity.hide();
        // $("#cartLimitA22").hide();
        // $("#count-down22").hide();
      }
    }, 1000);
  },
};
lottery.mark = {
  get() {
    lottery.data.mark.view = localStorage.getItem("lottery_view");
    lottery.data.mark.addtocart = localStorage.getItem("lottery_add_to_cart");
    lottery.data.mark.checkout = localStorage.getItem("lottery_checkout");
  },
};
lottery.step = {
  show() {
    lottery.base.show()
    $(".lottery-step-main").show();
    lottery.data.popup_source = 1;
    bloomchic_sensor?.lottery?.CouponPopupShow();
  },
  hide() {
    lottery.base.hide()
    $(".lottery-step-main").hide();
  },
};

var lottery_abtest_loaded = false;
function changeAB()  {
  $(".lottery-base").addClass("lottery-base-"+lottery.data.ab_type); // 设置方案
  var isB = lottery.data.ab_type === 'B'
  if (isB) {
    window.lottery_prize = $.extend(window.lottery_prize, window.lottery_prize_b);
    $(".lottery-giveup-close").text('Give up chance for 15% off');
    $(".lottery-logo2-body span").text("15% OFF");
  }
}
function initPage() {
  changeAB()
  lottery.data.is_lottery = true;
  lottery.activity.login();
  lottery.activity.get_email();
  lottery.activity.get_lotteryTime();
  lottery.activity.get_last_auto_show_time();
  lottery.activity.get_close_activity_time();
  const openRes = lottery.activity.check_email();
  lottery.activity.get_result();
  lottery.mark.get();
  $(".lottery-logo-body").click(function () {
    if (lottery.data.lottery_time == null) {
      lottery.wheel.show();
    } else {
      lottery.prize.show();
    }
    lottery.logo.hide();
    bloomchic_sensor?.lottery?.SpinEntryClick();
  });

  $(".lottery-logo-close").click(function () {
    lottery.activity.hide();
    bloomchic_sensor?.lottery?.SpinEntryCloseClick();
  });

  $(".lottery-wheel-close, .lottery-wheel-nothank-email span, .lottery-close-nothank").click(function () {
    lottery.wheel.hide();
    lottery.base.show();
    // lottery.logo.show();
    setTimeout(() => {
      // lottery.giveup.show(2);
      lottery.base.hide();
      lottery.logo.show();
      bloomchic_sensor?.lottery?.CloseButtonClick(1);
    }, 500)
  });

  $(".lottery-giveup-stay").click(function () {
    lottery.giveup.hide();
    bloomchic_sensor?.lottery?.CloseConfirmClick(1);
    lottery.wheel.show();
  });

  $(".lottery-giveup-close").click(function () {
    lottery.giveup.hide();
    lottery.logo.show();
    bloomchic_sensor?.lottery?.CloseConfirmClick(2);
  });

  $(".lottery-wheel-form-button").click(async function () {
    // 校验邮箱是否通过
    function checkEmailStatus(email='') {
      return new Promise((resolve, reject) => {
        const post_data = { email }
        $.getJSON(
          lottery_api_address + "/lottery/status",
          post_data,
          function (data, textStatus, jqXHR) {
            switch (data.code) {
              case 200:
                lottery.data.has_order = data.data.order;
                if (!lottery.data.has_order) {
                  if (data.data.lottery != "") {
                    lottery.data.lottery_time = new Date(
                      data.data.lottery.created_time * 1000
                    );
                    lottery.data.prize_code = data.data.lottery.code;
                    lottery.data.result = data.data.lottery.result;
                    lottery_prize_img_src = window.lottery_prize[lottery.data.result];
                    lottery_prize_ticket_img_src = window.lottery_prize[lottery.data.result];
                  }
                }
                resolve('200')
                break;
              case 20010:
                $(".lottery-wheel-form-email-error .used").show();
                handle_email_error(4, email);
                resolve('20010')
                break;
              case 20009:
                $(".lottery-wheel-form-email-error .only-new").show();
                handle_email_error(3, email);
                resolve('20009')
                break;
              default:
                $(".lottery-wheel-form-email-error .network").show();
                throw new Error('Lottery Get Is Error') // 可以触发上报
            }

          }
        ).fail(function () {
          lottery.wheel.error()
          $(".lottery-wheel-form-email-error .network").show();
          throw new Error('Lottery Get Is Error') // 可以触发上报
        })
      })

    }
    lottery.data.click_item = lottery.data.pointer_clicking ? 2 : 1;
    var email = $(".lottery-wheel-form-email").val();
    if (email == "") {
      $(".lottery-wheel-email .lottery-wheel-form-input-border").addClass("empty-error");
      $(".lottery-wheel-form-email-error div").hide();
      $(".lottery-wheel-form-email-error .empty").show();
      var animation_name = $(".lottery-wheel-form-input-border").css("animation-name");
      if (animation_name == "none") {
        $(".lottery-wheel-form-input-border").css("animation-name","upAnimation");
      }
      handle_email_error(2, email);
      setTimeout(() => {
        $(".lottery-wheel-form-input-border").css("animation-name", "none");
      }, 2200);
      return
    }
    var phone = "";// $(".lottery-wheel-form-phone").val().toLocaleLowerCase().trim().replace(/\D/g, "");
    var agree = lottery.data.ab_type != 'B'
    try {
      if (lottery.wheel.verify(email, phone, agree)) {
        lottery.data.lotterying = true
        lottery.wheel.loading();
        const checkEmailRes = await checkEmailStatus(email)
        lottery.data.lotterying = false;
        // 校验不通过
        if (checkEmailRes != 200) {
          // $('.lottery-wheel-form-button, .lottery-wheel-pointer').removeClass('noclick')
          // $(".lottery-wheel-form-email-error div").hide()
          // $(".lottery-wheel-form-button span").text('Spin the wheel');
          // clearInterval(lottery.loading_interval)
          return
        }
        // lottery.wheel.action(email, phone);
        $('.lottery-wheel-email').addClass('hide')
        $(".lottery-wheel-form-button").addClass('hide')
        $('.lottery-wheel-phone-button').removeClass('hide')
        $('.lottery-wheel-close').addClass('hide')
        $('.lottery-wheel-phone-close').removeClass('hide')
        $('.lottery-wheel-phone').removeClass('hide')
        $('.lottery-wheel-nothank').addClass('hide')
        $('.lottery-wheel-nothank-phone').removeClass('hide')
      }
    } catch(err) {
      lottery.wheel.error()
      throw new Error('Lottery Get Is Error') // 可以触发上报
    }

    // $('.lottery-wheel-form-button, .lottery-wheel-pointer').addClass('noclick')
    // if (!lottery.data.lotterying) {
    //   var email = $(".lottery-wheel-form-email").val().toLocaleLowerCase().trim();
    //   var phone = "";// $(".lottery-wheel-form-phone").val().toLocaleLowerCase().trim().replace(/\D/g, "");
    //   var agree = lottery.data.ab_type != 'B'
    //   if (lottery.wheel.verify(email, phone, agree)) {
    //     lottery.wheel.action(email, phone);
    //     theme.fetch.uidSubscribe(email, 1)
    //     window.pptag && window.pptag.send('store_cash_exclusion')
    //   }
    // }
  });
  $('.lottery-wheel-phone-close, .lottery-wheel-nothank-phone span').click(() => {
    if ($('.lottery-wheel-form-button').hasClass('noclick')) {
      return
    }
    lottery.data.click_item = 3
    bloomchic_sensor?.lottery?.CloseButtonClick(2);
    lotteryEmail()
  })
  $(".lottery-wheel-phone-button").click(lotteryPhoneClick);

  $('#lottery-agree-status').change(function() {
    lottery.wheel.verify($(".lottery-wheel-form-email").val().toLocaleLowerCase().trim())
  })

  $(".lottery-prize-bottom").click(function () {
    lottery.prize.hide();
    lottery.logo.show();
    bloomchic_sensor?.lottery?.ContinueShoppingClick();
  });
  $(".lottery-close").click(function() {
    lottery.base.hide();
    lottery.prize.hide();
    lottery.wheel.hide();
    lottery.logo.show();
  })

  $(".lottery-wheel-msg a").click(function () {
    var value = $(this).text().trim();
    var result = 1;
    switch (value) {
      case "Activity Rules":
        result = 1;
        break;
      case "Terms of Service":
        result = 2;
        break;
      case "Privacy Policy":
        result = 3;
        break;
    }
    bloomchic_sensor?.lottery?.RulesClick(result);
  });
  console.log('openRes', openRes)
  return openRes
}
function initEvents() {
  $(".lottery-wheel-form-email").blur(function () {
    lottery.wheel.verify($(this).val().toLocaleLowerCase(), '', false);
  });
  $(".lottery-logo2-body").click(function () {
    lottery.wheel.show();
    lottery.logo.hide();
    bloomchic_sensor?.lottery?.SpinEntryClick();
  });
  $(".lottery-step-close").click(function () {
    lottery.step.hide();
    // lottery.giveup.show(1);
    lottery.logo.show();
    bloomchic_sensor?.lottery?.CouponPopupCloseClick();
  });
  $(".lottery-step-btn, .lottery-step-gifimg").click(function () {
    lottery.step.hide();
    lottery.wheel.show();
    bloomchic_sensor?.lottery?.CouponPopupButtonClick();
  });
  $(".lottery-logo2-close").click(function (event) {
    event.stopPropagation();
    lottery.activity.hide();
    bloomchic_sensor?.lottery?.SpinEntryCloseClick();
  });
  $(".lottery-wheel-form-email").on("input", function () {
    var email = $(this).val();
    if (email != "") {
      $(".lottery-wheel-email .lottery-wheel-form-input-border").removeClass("empty-error");
      $(".lottery-wheel-form-error div").hide();
      $(".lottery-wheel-form-input-border").css("animation-name", "none");
    } else {
      $(".lottery-wheel-email .lottery-wheel-form-input-border").addClass("empty-error");
      $(".lottery-wheel-form-email-error div").hide();
      $(".lottery-wheel-form-error .empty").show();
    }
  });
  $(".lottery-wheel-phone-input").on("input", function () {
    var phone = $(this).val();
    console.log('phonephone', phone)
    if (phone != "") {
      $(".lottery-wheel-phone .lottery-wheel-form-input-border").removeClass("empty-error");
      $(".lottery-wheel-form-error div").hide();
      $(".lottery-wheel-form-input-border").css("animation-name", "none");
    } else {
      $(".lottery-wheel-phone .lottery-wheel-form-input-border").addClass("empty-error");
      $(".lottery-wheel-phone-error div").hide();
      $(".lottery-wheel-form-error .empty").show();
    }
  });
  $(".lottery-wheel-close").click(function () {
    $(".lottery-wheel-form-input-border").css("animation-name", "none");
    $(".lottery-wheel-form-input-border").removeClass("empty-error");
  });
  $(".lottery-wheel-pointer").click(function () {
    lottery.data.pointer_clicking = true;
    $(".lottery-wheel-form-button").click();
  });
}

var logo2_animation_interval = null;
function logo2_animation() {
  $(".lottery-logo2-image").css("animation-name", "upAnimation");
  setTimeout(() => {
    $(".lottery-logo2-image").css("animation-name", "none");
  }, 2500);
  clearInterval(logo2_animation_interval);
  logo2_animation_interval = setInterval(() => {
    $(".lottery-logo2-image").css("animation-name", "upAnimation");
    setTimeout(() => {
      $(".lottery-logo2-image").css("animation-name", "none");
    }, 2500);
  }, 20000);
}

// 这个函数将在message.vue中调用，接管弹窗逻辑
lottery.init = function () {
  if (!location.pathname.includes('/account')) {
    lottery_abtest_loaded = true;
    initEvents();
    // lottery.wheel.show();
    return initPage();
  }
  return false
  // var ab_name = "";
  // var ab_enabled = false;
  // if (ab_name && ab_enabled) {
  //   bloomchic_sensor.abtest.fastFetchABTest({
  //     param_name: ab_name,
  //     default_value:"A",
  //     value_type:"String",
  //     callback: function(result){
  //       console.log("抽奖Test=>", result)
  //       lottery.data.ab_type = result;
  //       initEvents();
  //       initPage();
  //       // TODO 请根据 result 进行自己的试验，当前试验对照组返回值为：A，试验组依次返回：B
  //     }
  //   })
  // } else {
  // initEvents();
  // initPage();
  // }
}
